<div class="modal-content draggable">
    <div style="padding-bottom: 36px" class="modal-header" [ngClass]="{'rask-dialog-header-info' : highestSeverity === 0,
                    'rask-dialog-header-warning' : highestSeverity === 1,
                    'rask-dialog-header-error' : highestSeverity === 2}">
    <h4 class="modal-title">{{header}} @if (messages?.length > 1) {
      <span>&nbsp;({{ messages.length}})</span>
    }
  </h4>
</div>
<div class="modal-body">
  @for (message of getMessages(); track message) {
    <div>
      @if (message.validationMessages) {
        <div>
          <table class="table is-hoverable">
            <thead>
              <tr>
                <th class="severity-header">{{'VALIDATION_SEVERITY' |
                translate}}</th>
                <th>{{'VALIDATION_MESSAGE' | translate}}</th>
              </tr>
            </thead>
            <tbody>
              @for (item of message.validationMessages; track item) {
<tr [ngClass]="{'rask-dialog-text-info' : item.severity === 0,
                          'rask-dialog-text-warning' : item.severity === 1,
                          'rask-dialog-text-error' : item.severity === 2 }">
                  <td style="text-align: center">
                                <i class="fas" [ngClass]="{
                          'fa-info-circle' : item.severity === 0,
                          'fa-exclamation-circle' : item.severity === 1,
                          'fa-ban' : item.severity === 2}"></i>
                  </td>
                  <td>
                    {{item.message}}
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
      @if (!message.validationMessages) {
        <div>
          @if (message.message) {
            <div
              [ngClass]="{ 'rask-dialog-text-info' : highestSeverity === 0, 'rask-dialog-text-warning' : highestSeverity === 1, 'rask-dialog-text-error' : highestSeverity === 2 }">
            {{message.message}}</div>
          }
          @if (!message.message) {
            <div
              [ngClass]="{ 'rask-dialog-text-info' : highestSeverity === 0, 'rask-dialog-text-warning' : highestSeverity === 1, 'rask-dialog-text-error' : highestSeverity === 2 }">
            Kunde inte ansluta till extern tjänst. Försök igen senare.</div>
          }
        </div>
      }
    </div>
  }
</div>
<div class="modal-footer d-flex justify-content-between">
  @if (hasCopy()) {
    <fieldset ignore-readonly class="mr-auto p-2">
      <button type="button" class="btn btn-secondary"
      (click)="copy()">{{'VALIDATION_BUTTON_COPY' | translate}}</button>
    </fieldset>
  }
  <fieldset ignore-readonly class="p-2">
    <button type="button" class="btn btn-primary"
    (click)="done()">{{'VALIDATION_BUTTON_DONE' | translate}}</button>
  </fieldset>
  @if (hasForce()) {
    <fieldset ignore-readonly class="p-2">
      <button type="button" class="btn btn-secondary"
      (click)="force()">{{'VALIDATION_BUTTON_FORCE' | translate}}</button>
    </fieldset>
  }
</div>
</div>